var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7207 23.369C1.7207 12.7677 10.3146 4.17383 20.9154 4.17383C31.5166 4.17383 40.1105 12.7677 40.1105 23.369C40.1105 33.9702 31.5166 42.5645 20.9154 42.5645C10.3146 42.5645 1.7207 33.9702 1.7207 23.369Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5246 22.9913C32.5169 18.0757 29.4443 13.8834 25.1148 12.2232V33.7585C29.4443 32.0961 32.5169 27.9077 32.5246 22.9913ZM16.8555 33.7544V12.2254C12.5298 13.8908 9.46193 18.0771 9.45035 22.9914C9.46193 27.9044 12.5298 32.0902 16.8555 33.7544ZM20.9873 4.78887C10.9348 4.79273 2.79049 12.9387 2.78878 22.9913C2.79049 33.0425 10.9348 41.1872 20.9873 41.1889C31.0398 41.1872 39.1859 33.0425 39.1884 22.9913C39.1859 12.9387 31.0398 4.79273 20.9873 4.78887ZM20.9427 42.9067C9.94247 42.9591 0.888672 34.0473 0.888672 23.199C0.888672 11.3429 9.94247 3.14239 20.9427 3.14453H26.0976C36.9679 3.14239 46.8887 11.339 46.8887 23.199C46.8887 34.0434 36.9679 42.9067 26.0976 42.9067H20.9427Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.30e49b27eb7d4e5f27f5f3276c7efb5f.svg";
export { ForwardRef as ReactComponent };